/**
 * "Live status" PageRail item → the Equipment & Room Status board (/equipment-rooms).
 *
 * Shared by the Equipment master, Equipment Logs and Cleaning Logs pages. Gated exactly like the
 * menu item (menu-items/dashboard.js: anyOf('Dashboard', 'Equipment Master', 'Cleaning Logs')), so a
 * user who cannot open the board from the menu never sees the tab either.
 *
 * Pass `equipment` (a bp_machine id — the same id the board and both log pages use) or `room` (a
 * location-node id) to open the board pre-filtered; the board reads ?equipment= / ?room=.
 */
import { Radio } from 'lucide-react';
import { accessControlUtils } from '@/components/AccessControlUtils';

const LIVE_STATUS_KEYS = ['Dashboard', 'Equipment Master', 'Cleaning Logs'];

export const canSeeEquipmentRoomStatus = () => LIVE_STATUS_KEYS.some((k) => accessControlUtils(k)?.read_access);

export const equipmentRoomsUrl = ({ equipment, room } = {}) => {
  const qs = new URLSearchParams();
  if (equipment !== undefined && equipment !== null && equipment !== '') qs.set('equipment', String(equipment));
  if (room !== undefined && room !== null && room !== '') qs.set('room', String(room));
  const s = qs.toString();
  return s ? `/equipment-rooms?${s}` : '/equipment-rooms';
};

/** A PageRail item, or null when the user may not open the board (PageRail skips nulls). */
export const liveStatusRailItem = (navigate, filter = {}) => {
  if (!canSeeEquipmentRoomStatus()) return null;
  const pre = filter.equipment ? ' — this equipment' : filter.room ? ' — this room' : '';
  return {
    key: 'live-status',
    icon: Radio,
    label: `Live status${pre} (Equipment & Room Status)`,
    onClick: () => navigate(equipmentRoomsUrl(filter)),
    testId: 'rail-live-status',
  };
};
